import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getAdminToken } from '../../utils/adminRequest';

function AdminGuard() {
  const token = getAdminToken();
  if (!token) {
    return <Navigate to="/admin" replace />;
  }
  return <Outlet />;
}

export default AdminGuard;
